import React, { FC, useContext, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { ConfigContext, Language } from "@app/provider";
import { SpinnerView } from "@app/components";
import { UPSUpdatePaymentMethodForm } from "@app/ups/components";
import { useIntl } from "react-intl";

const STRIPE_APPEARANCE = {
  rules: {
    ".TermsText": {
      fontFamily: '"Roboto Flex", sans-serif',
      fontSize: "12px",
      lineHeight: "18px",
      letterSpacing: "0.005em",
      color: "#0000008F",
      fontWeight: "400",
    },
  },
};

interface Props {
  clientSecret: string;
  customerSessionSecret: string;
  loading: boolean;
}

const UPSUpdatePaymentMethodContainer: FC<Props> = ({
  clientSecret,
  customerSessionSecret,
  loading,
}) => {
  const { config } = useContext(ConfigContext);
  const { locale } = useIntl();
  const currentLocale = locale === "es" ? Language.ES : Language.EN;
  const publishableKey = config.preBill.postBillStripeKey;

  const stripePromise = useMemo(
    () => loadStripe(publishableKey, { locale: currentLocale }),
    [publishableKey, currentLocale]
  );

  const elementsOptions = useMemo(
    () => ({
      clientSecret,
      customerSessionClientSecret: customerSessionSecret,
      appearance: STRIPE_APPEARANCE,
    }),
    [clientSecret, customerSessionSecret]
  );

  return (
    <>
      <SpinnerView isLoading={loading} />
      {clientSecret && (
        <Elements
          stripe={stripePromise}
          options={elementsOptions}
          key={currentLocale}
        >
          <UPSUpdatePaymentMethodForm />
        </Elements>
      )}
    </>
  );
};

export default UPSUpdatePaymentMethodContainer;
